import { useEffect, useState } from 'react';
import { storeService } from '../services/storeService';
import { VariationOption } from '../models';
import { groupVariationOptions, VariationTypeGroup } from '../utils/variationCatalog';

interface UseVariationCatalogResult {
  types: VariationTypeGroup[];
  isLoading: boolean;
  error: Error | null;
  isEmpty: boolean;
}

export function useVariationCatalog(): UseVariationCatalogResult {
  const [options, setOptions] = useState<VariationOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let active = true;
    setIsLoading(true);
    setError(null);

    storeService
      .getVariationOptions()
      .then((data) => {
        if (active) setOptions(data);
      })
      .catch((err) => {
        if (active) setError(err instanceof Error ? err : new Error('Erro ao carregar variações'));
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });

    return () => {
      active = false;
    };
  }, []);

  const types = groupVariationOptions(options);

  return { types, isLoading, error, isEmpty: types.length === 0 };
}
